var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-button",class:{ danger: _vm.color === 'danger', 'botao-whatsapp': this.botaoWhatsapp },style:(_vm.color),attrs:{"title":_vm.title}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }